import { render, staticRenderFns } from "./ui-switcher.vue?vue&type=template&id=d316f46e&"
import script from "./ui-switcher.vue?vue&type=script&lang=ts&"
export * from "./ui-switcher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports